export default __webpack_public_path__ + "fb07468f68c58f89c1f6148030b67caa.webp";